import { BackLink } from '@avanta/shared/components/BackLink';
import { Button } from '@avanta/shared/components/ui/Button';
import { InputOTP } from '@avanta/shared/components/ui/InputOTP';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { clearRecoveryCookies } from '@avanta/shared/utils/auth';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'constants/routes';
import { ErrorMessage } from '../ErrorMessage';
import { type VerificationStepProps } from './types';

export const CodeVerification = ({
  onVerifyCode,
  onResendCode,
  error,
  isLoading,
}: VerificationStepProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.AUTH);

  return (
    <div className="flex flex-col gap-6 w-full">
      <p className="text-center text-gray-600">{t('RecoverPassword.Verification.body')}</p>
      <InputOTP onVerifyCode={onVerifyCode} steps={6} disabled={isLoading} />
      <ErrorMessage message={error?.message} />
      <Button variant="link" onClick={onResendCode} disabled={isLoading}>
        {t('RecoverPassword.Verification.resend.cta')}
      </Button>
      <BackLink
        to={ROUTES.LOGIN}
        onClick={clearRecoveryCookies}
        label="RecoverPassword.backToLogin"
        i18nNs={LOCIZE_NS.AUTH}
      />
    </div>
  );
};
